// React
import { useContext } from "react"

// Components
import { Button, Input, Modal } from "components"

// Contexts
import { PoContext } from "../contexts"

// Icons
import { TbInfoCircle } from "react-icons/tb"

// Utils
import { useToggle } from "utils"
import { Detail } from "../../PurchaseOrder/components"

export function LinkPurchase(): JSX.Element {
  // Hooks
  const data = useContext(PoContext)

  return (
    <section className="flex items-end">
      <section className="grow">
        <Input
          disabled
          inputClass="rounded-r-none"
          label="LINK TO PURCHASE ID"
          value={data.datapo.trx_code}
        />
      </section>

      <DetailSection />
    </section>
  )
}

function DetailSection(): JSX.Element {
  // Hooks
  const data = useContext(PoContext)
  const { isActive, toggle } = useToggle(false)

  return (
    <>
      <Button
        type="button"
        color="primary"
        onClick={toggle}
      >
        <TbInfoCircle />
      </Button>

      {isActive && (
        <Modal
          isOpen
          title="PURCHASE ORDER DETAIL"
          closeModal={toggle}
        >
          <Modal.Body>
            <Detail purchase_order_id={data.purchase_order_id.toString()} />
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}